import Api from "./Api";

export default {
  getAllCampaignsGrid(companyId) {
    return Api().get(`/campaigns/${companyId}`);
  },
  getAllCampaigns(companyId) {
    return Api().get(`/campaigns/${companyId}`);
  },
  addCampaign(payload) {
    return Api().post(`/campaigns/${payload.companyId}`, payload.data);
  },
  editCampaign(payload) {
    return Api().post(
      `/campaigns/${payload.companyId}/${payload.id}`,
      payload.data
    );
  },
  deleteCampaign(payload) {
    return Api().delete(`/campaigns/${payload.companyId}/${payload.id}`);
  },
  bulkDeleteCampaigns(payload) {
    return Api().post(
      `/campaigns/${payload.companyId}/bulk-delete`,
      payload.data
    );
  },
  getCampaignById(payload) {
    return Api().get(`/campaigns/${payload.companyId}/${payload.id}`);
  },
};
